import { fetchGET,fetchPOST } from '../api/fetchers'
import { localStorage,decodeKbank } from '../utils'
import Toastify from 'spc-general-component/lib/Toastify'
import get from 'lodash/get'
import productModule from '../modules/product'
import isEmpty from 'lodash/isEmpty'
import moment from 'moment'
import {gtmPurchases} from '../utils/pushGTM'
const ENCRYPTION_ROUND = 3
const KBANK_SECRETE_KEY = process.env.REACT_APP_KBANK_SECRET_KEY || ''
const KBANK_PAYMENT_MID = process.env.REACT_APP_KBANK_PAYMENT_MID || ''
const KBANK_PAYMENT_TID = process.env.REACT_APP_KBANK_PAYMENT_TID || ''
const KBANK_HOST = process.env.REACT_APP_KBANK_HOST || ''
const HOST = process.env.REACT_APP_HOST || ''
const COMPANY_CHIANGMAI_CODE = process.env.REACT_APP_COMPANY_CHIANGMAI_CODE || ''
const COMPANY_CODE = process.env.REACT_APP_COMPANY_CODE || ''
const ORG_CODE = process.env.REACT_APP_ORG_CODE || ''
const HOST_OTP = process.env.REACT_APP_OTP_HOST || ''
const ShoppingStorage = process.env.REACT_APP_SHPOPPING_STORAGE || 'SPC-SHOPPING-LIST'
const CREATE_BY = process.env.REACT_APP_CREATE_BY || ''
const CouponStorage = process.env.REACT_APP_COUPON || ''
const CIDStorage = process.env.REACT_APP_CID || ''
const ShippingStorage = process.env.REACT_APP_SHIPPING || ''

const onDecodeData = (_data, _jsonParse = true, _round = ENCRYPTION_ROUND) => {
	try {
		if (_data === null || _data === undefined) {
			return null;
		}
		let newData = _data;
		for (let i = 0; i < _round; i++) {
			newData = decodeURIComponent(escape(atob(newData)));
		}
		return _jsonParse ? JSON.parse(newData) : newData;
	} catch (error) {
		console.log('DECODE_STORAGE', error);
		return null;
	}
}

const onEncodeData =  (_data, _jsonStringify = true, _round = ENCRYPTION_ROUND) => {
  try {
		if (_data === null || _data === undefined) {
			return null;
		}
		let newData = _jsonStringify ? JSON.stringify(_data) : _data;
		for (let i = 0; i < _round; i++) {
			newData = btoa(unescape(encodeURIComponent(newData)));
		}
		return newData;
	} catch (error) {
		console.log('ENCODE_STORAGE', error);
		return null;
	}
}
const onInQuiryQRPaymentAction = async({order_id}) => {
    try {
    
      const response = await fetchGET({
        url: `${KBANK_HOST}/qr/v2/qr/${order_id}`,
        headers:{
          'x-api-key': decodeKbank(KBANK_SECRETE_KEY,false)
        }
      })

      return response
     
    } catch (errro) {
      Toastify({
        position: 'center', // left, right, center is default
        type: 'ERROR', // ERROR, WARNING, LOADING, INFO
        message: 'API Get InQuiry QR Action is not working',
        closeTime: 5 // Seconds
      })
    }
  
}

const onCreateChargePaymentAction = async(_createObj) => {
    try {
    
      const response = await fetchPOST({
        url: `${KBANK_HOST}/card/v2/charge`,
        headers:{
          'Content-Type': 'application/json',
          'x-api-key': decodeKbank(KBANK_SECRETE_KEY,false)
        },
        data:{
          amount: _createObj.amount,
          token: _createObj.token,
          currency: _createObj.currency,
          description: _createObj.description,
          source_type: 'card',
          mode: 'token',
          reference_order: _createObj.reference_order,
          ref_1: '',
          additional_data: {
              mid: KBANK_PAYMENT_MID,
              tid: KBANK_PAYMENT_TID
          }
        }
      })

      return response
     
    } catch (errro) {
      Toastify({
        position: 'center', // left, right, center is default
        type: 'ERROR', // ERROR, WARNING, LOADING, INFO
        message: 'API Get Create Charge Payment Action is not working',
        closeTime: 5 // Seconds
      })
    }
  
}


const onUpdateCIDPaymentAction = async(paymentno, cid, paymentType = 'card') => {
  
    try {
      const cidStorage = localStorage.get(CIDStorage)
      const cidFormat = JSON.parse(cidStorage)
      
      const response = await fetchPOST({
        url: `${HOST}/sahapatdelivery/creditcardResultUpdate`,
        data: {
          orgcode: ORG_CODE,
          companycode: COMPANY_CODE,
          bankrefno: cidFormat?.invmerchant,
          paymentno: paymentno,
          bank_cid: cid
      }
        
      })

      localStorage.set({
        'key': CIDStorage,
        value: JSON.stringify({
          paymentno: paymentno,
          cid: cid,
          paymentType: paymentType
        })
      })
      
      return response
     
    } catch (errro) {
      Toastify({
        position: 'center', // left, right, center is default
        type: 'ERROR', // ERROR, WARNING, LOADING, INFO
        message: 'API Get Update CID Action is not working',
        closeTime: 5 // Seconds
      })
    }
  
}

const onCheckPaymentCRQRAction = () => {
  return async (dispatch,getState) => {
  try {
    const cid = localStorage.get(CIDStorage)
    const coupon = localStorage.get(CouponStorage)
    const shipping = localStorage.get(ShippingStorage)
    const couponFormat = JSON.parse(coupon)
    const cidFormat = JSON.parse(cid)
    const shippingFormat = JSON.parse(shipping)
    const customerInfo = get(getState(), 'customer.customerProfile', {})
    const shoppingCart = get(getState(), 'product.shoppingCart', [])
    const cidFormatTemp = JSON.parse(cid)

    let result = {}
    
    //Cash On Delivery
    if(cidFormat.paymentType === 'T'){

      await gtmPurchases({
        products:shoppingCart,
        orderObj:{
          'id':  cidFormat.orderNo || '', // Transaction ID. Required for purchases and refunds.						
          'revenue': cidFormat.amount || 0, // Total transaction value (incl. tax and shipping)
          'shipping': shippingFormat?.trnsprice || 0,
          'coupon': couponFormat?.couponcode || '',
        }
      })
      
      localStorage.remove(ShoppingStorage)
      localStorage.remove(ShippingStorage)
      dispatch(productModule.setData({
        data: {
          'shoppingCart':[]
        }
      }))
      
      result ={
        success: true,
        paymentType: cidFormat.paymentType,
        result:[{
          reference_order: cidFormat.orderNo
        }]
      }

      const responseToken = await fetchPOST({
        url: `${HOST_OTP}/auth/generateTokenWrapper`,
      })
      const token = get(responseToken,'data.result.token','')

      try {
        await fetchPOST({
          url: `${HOST_OTP}/v2/b2b/sms/send`,
          headers:{
            Authorization: `Bearer ${token}`
          },
          data: {
            sender: 'SAHAPAT',
            phonelist: customerInfo.telephone,
            message: 'ขอขอบคุณที่ใช้บริการ SAHAPAT DELIVERY เราได้รับรายการสั่งซื้อของท่านแล้ว กรุณารอรับสินค้า ขอบคุณค่ะ',
          }
        })

        await fetchPOST({
          url: `${HOST_OTP}/v1/b2b/sms/send`,
          headers:{
            Authorization: `Bearer ${token}`
          },
          data: {
            sender: 'SAHAPAT',
            phonelist: customerInfo.telephone,
            message: 'ขอขอบคุณที่ใช้บริการ SAHAPAT DELIVERY เราได้รับรายการสั่งซื้อของท่านแล้ว กรุณารอรับสินค้า ขอบคุณค่ะ',
          }
        })
      } catch (error) { }
      
      // update user use coupon
      if(!isEmpty(couponFormat)){

        await fetchPOST({
          url: `${HOST}/customer/updatestatuscustomercoupon`,
          data: {
              "orgcode": ORG_CODE,
              "companycode": COMPANY_CODE,
              "customercode": customerInfo?.customercode,
              "couponcode": couponFormat?.couponprefix,
              "couponcodeunique": couponFormat?.couponcode
          }
        })

        await fetchPOST({
          url: `${HOST}/customer/insertcustomercouponorder`,
          data: {
              "orgcode": ORG_CODE,
              "companycode": COMPANY_CODE,
              "customercode": customerInfo?.customercode,
              "documentno": get(result,'result[0].reference_order',''),
              "documentdate": moment().format('YYYY-MM-DD HH:mm:ss'),
              "couponcode": couponFormat?.couponcode,
              "couponvalue": couponFormat?.couponvalue,
              "percentvalue": couponFormat?.percentvalue,
              "createby": CREATE_BY
          }
        })
        localStorage.remove(CouponStorage)
      }
    }

    //QR Payment && Credit Card Payment
    if(cidFormat.paymentType !== 'T'){
      const response = await fetchPOST({
        url: `${HOST}/sahapatdelivery/checkPaymentCRQR`,
        data: {
          paymentno: cidFormat.paymentno,
          paymenttype: cidFormat.paymentType === 'qr' ? cidFormat.paymentType: 'cr',
          bank_cid: cidFormat.cid,
        }
      })
     
      result = get(response,'data',{})

      if (result?.success) {
        await gtmPurchases({
          products:shoppingCart,
          orderObj:{
            'id':  get(result,'result[0].reference_order',''), // Transaction ID. Required for purchases and refunds.						
            'revenue': get(result,'result[0].amount',0), // Total transaction value (incl. tax and shipping)
            'shipping': shippingFormat?.trnsprice || 0,
            'coupon': couponFormat?.couponcode || '',
          }
        })
        localStorage.remove(ShoppingStorage)
        localStorage.remove(ShippingStorage)
        dispatch(productModule.setData({
          data: {
            'shoppingCart':[]
          }
        }))
        const responseToken = await fetchPOST({
          url: `${HOST_OTP}/auth/generateTokenWrapper`,
        })
        const token = get(responseToken,'data.result.token','')
  
        try {
          await fetchPOST({
            url: `${HOST_OTP}/v2/b2b/sms/send`,
            headers:{
              Authorization: `Bearer ${token}`
            },
            data: {
              sender: 'SAHAPAT',
              phonelist: customerInfo.telephone,
              message: 'ขอขอบคุณที่ใช้บริการ SAHAPAT DELIVERY เราได้รับรายการสั่งซื้อของท่านแล้ว กรุณารอรับสินค้า ขอบคุณค่ะ',
            }          
          })

          await fetchPOST({
            url: `${HOST_OTP}/v1/b2b/sms/send`,
            headers:{
              Authorization: `Bearer ${token}`
            },
            data: {
              sender: 'SAHAPAT',
              phonelist: customerInfo.telephone,
              message: 'ขอขอบคุณที่ใช้บริการ SAHAPAT DELIVERY เราได้รับรายการสั่งซื้อของท่านแล้ว กรุณารอรับสินค้า ขอบคุณค่ะ',
            }          
          })
        } catch (error) { }
      
        // update user use coupon
        if(!isEmpty(couponFormat)){
          await fetchPOST({
            url: `${HOST}/customer/updatestatuscustomercoupon`,
            data: {
                "orgcode": ORG_CODE,
                "companycode": COMPANY_CODE,
                "customercode": customerInfo?.customercode,
                "couponcode": couponFormat?.couponprefix,
                "couponcodeunique": couponFormat?.couponcode
            }
          })
  
          await fetchPOST({
            url: `${HOST}/customer/insertcustomercouponorder`,
            data: {
                "orgcode": ORG_CODE,
                "companycode": COMPANY_CODE,
                "customercode": customerInfo?.customercode,
                "documentno": get(result,'result[0].reference_order',''),
                "documentdate": moment().format('YYYY-MM-DD HH:mm:ss'),
                "couponcode": couponFormat?.couponcode,
                "couponvalue": couponFormat?.couponvalue,
                "percentvalue": couponFormat?.percentvalue,
                "createby": CREATE_BY
            }
          })
          localStorage.remove(CouponStorage)
        }
      } else {
        await fetchPOST({
          url: `${HOST}/b2b/v1/Order/cancelordernosend`,
          data: {
              "orderno": get(result,'result[0].reference_order','')          
          }
        })
      }
    }

    result ={
      success: result.success,
      paymentType: cidFormatTemp.paymentType,
      result:[{
        reference_order: cidFormatTemp.orderNo || cidFormatTemp.paymentno
      }]
    }

    return result
   
  } catch (errro) {
    Toastify({
      position: 'center', // left, right, center is default
      type: 'ERROR', // ERROR, WARNING, LOADING, INFO
      message: 'API Get Check Payment CR QR Action Action is not working',
      closeTime: 5 // Seconds
    })
  }
  }
}

const onClearCIDAction = () => {
  return async (dispatch) => {
  try {
    localStorage.remove(CIDStorage)
   
  } catch (errro) {
    Toastify({
      position: 'center', // left, right, center is default
      type: 'ERROR', // ERROR, WARNING, LOADING, INFO
      message: 'API Get Check Payment CR QR Action Action is not working',
      closeTime: 5 // Seconds
    })
  }
  }
}

const cancelOrderByOrderNoAction = (orderNo) => {
  return async (dispatch) => {
    try {
      await fetchPOST({
        url: `${HOST}/b2b/v1/Order/cancelordernosend`,
        data: {
            "orderno": orderNo
        }
      })    
    } catch (errro) {
      Toastify({
        position: 'center', // left, right, center is default
        type: 'ERROR', // ERROR, WARNING, LOADING, INFO
        message: 'API cancelOrderByOrderNoAction is not working',
        closeTime: 5 // Seconds
      })
    }
  }
}

export {
  onDecodeData,
  onInQuiryQRPaymentAction,
  onCreateChargePaymentAction,
  onUpdateCIDPaymentAction,
  onCheckPaymentCRQRAction,
  onClearCIDAction,
  cancelOrderByOrderNoAction
}